export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12212.a98c9ec7.jpg";